<template>
  <a-modal title="查看配方" 
    :visible="hidden" 
    @ok="ok" 
    @cancel="()=>$emit('cancel')" 
    okText="确定" 
    :bodyStyle="{padding:'0 20px 10px'}"
    cancelText="取消"
    :footer="null"
    :forceRender="true"
    :maskClosable="false"
    :destroyOnClose="true"
    width="1000px"
  >
    <a-tabs default-active-key="1" @change="tabChange">
      <a-tab-pane tab="原料" key="1">
        <a-table 
          :columns="columns" 
          :data-source="list.records"
          :row-key="record => record.id"
          :scroll="{ x:0, y: 240 }"
          :pagination="false"
          :loading='tabLoading'
        >
          <template slot="rawName" slot-scope="text,record">
            {{overseasFlag == '1' ? (record.aliasName || text) : text}}
          </template>
          <template
            v-for="uasge in ['uasge','percentage','minValue','maxValue']"
            :slot="uasge"
            slot-scope="text"
          >
          {{text|numberFixed(3)}}
          </template>

             <!-- 最小值 -->
          <!-- <template
            slot="minValue"
            slot-scope="text"
          >
            <span style="color:#2ab72b">{{ text === '' || text === null ? text : Number(text).toFixed(3)}}</span>
          </template> -->

          <!-- 最大值 -->
          <!-- <template
            slot="maxValue"
            slot-scope="text"
          >
            <span style="color:#f47920">{{ text === '' || text === null ? text : Number(text).toFixed(3)}}</span>
          </template> -->
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="营养分析" key="2">
        <a-table 
          :columns="columns1"
          :data-source="list.records"
          :row-key="record => record.id"
          :scroll="{ x:0, y: 240 }"
          :pagination="false"
          :loading="tabLoading"
        >

          <template
            v-for="uasge in ['content','minValue','maxValue']"
            :slot="uasge"
            slot-scope="text,record"
          >
          {{text|numberFixed(record.unit ==='MJ' || record.unit ==='Kcal' ? 0 : 2)}}
          </template>

            <!-- 最小值 -->
          <!-- <template
            slot="minValue"
            slot-scope="text"
          >
            <span style="color:#2ab72b">{{ text === '' || text === null ? text : Number(text).toFixed(3)}}</span>
          </template> -->

          <!-- 最大值 -->
          <!-- <template
            slot="maxValue"
            slot-scope="text"
          >
            <span style="color:#f47920">{{ text === '' || text === null ? text : Number(text).toFixed(3)}}</span>
          </template> -->

        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-row style="padding:6px 0;" type="flex" align="middle" justify="space-between" slot="footer">
     <div>
      <a-pagination 
        v-if="list.records" 
        :showSizeChanger="pagination.showSizeChanger" 
        :pageSizeOptions="pagination.pageSizeOptions" 
        :showTotal="pagination.showTotal" 
        :size="pagination.size" 
        :total="pagination.total" 
        :current="pagination.current"
      >
      </a-pagination>
     </div>
      <a-button type="primary" @click="()=>$emit('cancel')">关闭</a-button>
    </a-row>
    <div class='historyBox'>
      <p style="margin-bottom: 5px;font-weight: bold;">历史记录</p>
      <div class="historyList">
        <p style="margin-bottom: 5px;" v-for="(el,ind) in historyList" :key="el.id">{{`${ind + 1}. ${el.updateTime}，由 ${el.factoryName ? el.factoryName + ' 的' : ''} ${el.userName} ${el.context}。`}}</p>
      </div>
      <div style="text-align: right;">
        <a-pagination 
          v-if="historyList.length"
          :showSizeChanger="historyPagination.showSizeChanger"
          :pageSizeOptions="historyPagination.pageSizeOptions"
          :show-total="total => `共${total}条记录`"
          :page-size.sync="historyPagination.pageSize"
          :total="historyPagination.total"
          :current="historyPagination.current"
          @change="historyChange"
          @showSizeChange="historyShowSizeChange"
        >
        </a-pagination>
      </div>
    </div>
  </a-modal>
</template>

<script>
import {nhfMixins} from '../../untils'
export default {
  props:['hidden','formulaId'],
  mixins:[nhfMixins],
  data(){
    return {
      list:[],
      showPagination:false,
      tabLoading: false,
      columns:[
        {
          dataIndex:'rawName',
          title: '原料名称',
          width: 200,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          dataIndex:'rawCode',
          title: '代码',
          width: 100
        },
        {
          dataIndex:'percentage',
          scopedSlots: {customRender: 'percentage'},
          title: '用量(%)',
          width: 80
        },
        {
          dataIndex:'uasge',
          scopedSlots: {customRender: 'uasge'},
          title: '用量(批次量)'
        },
        {
          dataIndex:'unit',
          title: '单位',
          width: 80
          // align:'center'
        },
        {
          dataIndex:'minValue',
          title: '最小值',
          scopedSlots: {customRender: 'minValue'},
        },
        {
          dataIndex:'maxValue',
          title: '最大值',
          scopedSlots: {customRender: 'maxValue'},
        }
      ],
      columns1:[
        {
          dataIndex:'nutritionName',
          title:'指标名称'
        },
        {
          dataIndex:'nutritionFullName',
          title:'指标全称',
          // width:280
        },
        // {
        //   dataIndex:'nutritionCode',
        //   title:'指标代码'
        // },
        {
          dataIndex:'content',
          scopedSlots: {customRender: 'content'},
          title:'数值',
        },
        {
          dataIndex:'unit',
          title:'单位',
          // align:'center'
        },
        {
          dataIndex:'minValue',
          scopedSlots: {customRender: 'minValue'},
          title:'最小值'
        },
        {
          dataIndex:'maxValue',
          scopedSlots: {customRender: 'maxValue'},
          title:'最大值',
        }
      ],
      selectedRowKeys:[],
      pagination:{},
      historyList: [],
      historyPagination: {
        pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true
      },
      overseasFlag: window.localStorage.getItem('overseasFlag')
    }
  },
  watch:{
    hidden(val){
      this.current = 1
      if(val){
        this.getList({formulaId:this.formulaId})
        this.getHistoryList()
      }
    }
  },
  methods:{
    historyChange(current, pageSize){
      this.historyPagination.current = current
      this.getHistoryList({current,pageSize})
    },
    historyShowSizeChange(current, pageSize){
      this.historyPagination.current = 1
      this.historyPagination.pageSize = pageSize
      this.getHistoryList({current:1,pageSize})
    },
    getHistoryList(pagination){
      let {current=1,pageSize=20} = pagination || this.historyPagination
      let data = {
        current,size: pageSize,formulaId: this.formulaId
      }
      this.$get('/iot-log/formularecoderlog/page',data).then(res => {
        let {success,data} = res || {}
        if(success){
          let {records,current=1,size=20,total=0} = data;
          this.historyPagination.current = current
          this.historyPagination.pageSize = size
          this.historyPagination.total = total
          this.historyList = records || []
        }
      })
    },
    ok(){
      this.$emit('ok')
    },

    tabChange(current){
      this.list.records = []
      this.current = current
      this.getList()
    },
    
    getList(arg = {}) {
      this.loading = true
      this.$nextTick(() => {
        if(!this.formulaId) return
        const actions = this.current == 1 ? this.formulaRawNhfPage : this.formulaNutritionNhfPage
        this.fetchGet({
          actions,
          loading: 'tabLoading',
          showMessage: false,
          data:{
            formulaId:this.formulaId,
            factoryId:this.factoryId,
            ...arg,
            size:1000,
          },
          name:'list',
          isList:true
        })
      })
    },
    listChange(page){
      this.getList({...this.tablePageChange(page)})
    },
  }
}
</script>
<style lang="scss" scoped>
.historyBox{
  // background: #f2f2f2;
  margin-top: 20px;
  position: relative;
  // left: -20px;
  // right: -20px;
  // padding: 10px;
  // width: calc(100% + 40px);
  .historyList{
    max-height: 220px;
    overflow-y: auto;
  }
}
</style>
